import {
  useInitializeOrganisation,
  useOrganisation,
} from '@/app/redux/hooks/organisation';
import { useStudents } from '@/app/redux/hooks/students';
import { AppSidebar } from '@/common/ui/AppSidebar';
import { FeatureGateProvider } from '@/common/ui/FeatureGate';
import Navbar from '@/dashboard/Navbar';
import SettingsSidebar from '@/dashboard/SettingsView/SettingsSidebar';
import { Separator } from '@shadcn/components/separator';
import { SidebarProvider } from '@shadcn/components/sidebar';
import { useIsMobile } from '@shadcn/hooks/use-mobile';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';

export default function DashboardLayout() {
  const isMobile = useIsMobile();
  const location = useLocation();

  useStudents();
  const { isInitializing } = useInitializeOrganisation();

  const { entitlements, isLoading: isLoadingOrg } = useOrganisation();

  if (isInitializing || isLoadingOrg) {
    return null;
  }

  return (
    <FeatureGateProvider entitlements={entitlements}>
      <SidebarProvider>
        <DashboardContainer $isMobile={isMobile}>
          {location.pathname.includes('settings') ? (
            <SettingsSidebar />
          ) : (
            <AppSidebar />
          )}
          <MainContentContainer>
            <Navbar />
            <Separator />
            <OutletContainer>
              <Outlet />
            </OutletContainer>
          </MainContentContainer>
        </DashboardContainer>
      </SidebarProvider>
    </FeatureGateProvider>
  );
}

const DashboardContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  height: 100vh;
  width: 100%;
  padding: ${(props) => (props.$isMobile ? 0 : 12)}px;
  padding-left: 0px;
  background-color: #f5f5f5;
`;

const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  border: solid 1px hsl(var(--border));
  box-sizing: content-box;
`;

const OutletContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
`;
